import React from 'react';
import FeatureSection from '../components/FeatureSection';

const featureImage1 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810add_Frame%202%20(1).png';
const featureImage2 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fbcfe024b709a2c844009a_Group%201000005199%20(2).png';
const featureImage3 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fcd298966cbef7c479b72f_NPS%20CSAT.png';




function NPSPage() {
  return (
    <div className="flex flex-col">
      {/* Section 1 */}
      <FeatureSection
        image={featureImage1}
        title="Motivate your team to enhance Net Promoter Scores (NPS) and Customer Satisfaction (CSAT)"
        description="Inspire your team with targeted incentives to boost Net Promoter Scores (NPS) and Customer Satisfaction (CSAT), fostering outstanding customer experiences."
      />

      {/* Section 2 */}
      <FeatureSection
        image={featureImage2}
        title="Inspire your team to drive improvements in Net Promoter Scores (NPS) and Customer Satisfaction (CSAT)"
        description="Drive performance with purpose-built incentives that enhance NPS and CSAT, empowering your team to deliver memorable customer experiences."
        reverse
      />

      {/* Section 3 */}
      <FeatureSection
        image={featureImage3}
        title="Encourage your team to drive improvements in NPS and CSAT through exceptional service"
        description="Motivate your team with strategic rewards that drive higher NPS and CSAT, creating exceptional customer experiences."
      />
    </div>
  );
}

export default NPSPage;
